import Loader from "react-loader-spinner";
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, FormGroup, Modal, Popover, Row } from "react-bootstrap";
import { closeDuration, getCurrentDuration, getCurrentDurationName, getDurationList, setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import BihatmaTable from "../BihamtaTable";
import { Calendar2Check, Check2Circle, DashCircle, ExclamationCircle } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker2";
import moment from "moment-jalali";

const ModalDuration = (props) => {
    const dispatch = useDispatch();
    const [pendingClose, setPendingClose] = useState(false);
    const [changeResult, setChangeResult] = useState(null);
    const [currDuration, setCurrDuration] = useState(null);
    const [closeDurationData, setCloseDurationData] = useState();
    const { popData, setPopData } = props;
    const [list, setList] = useState({ Data: [] });
    const [pendingServices, setPendingServices] = useState(null);
    const { show } = popData;
    function close() {
        if (pendingClose) {
            return;
        }
        setChangeResult(null);
        setPopData({
            show: false
        })
    }
    const tableCols = [
        { colTitle: "نام دوره", colName: "DurationName" },
        { colTitle: "تاریخ شروع دوره", colName: "PDurationStartDate" },
        { colTitle: "تاریخ پایان دوره", colName: "PDurationEndDate" }
    ]
    const pendingServicesCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "نوع سرویس", colName: "PServiceType" },
        { colTitle: "شماره سرویس", colName: "InvoiceNumber" },
        { colTitle: "تاریخ سرویس", colName: "PFirstContactDate" }
    ]
    const tableRowButtons = [
        {
            type: "common", tooltip: "تغییر دوره مالی", icon: <Calendar2Check size={15} className="rowBtn" color="#5b23b5" />, onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'تغییر دوره مالی',
                    dialogText: 'آیا از تغییر دوره مالی مطمئن هستید؟',
                    okOperation: changeCurrentDuration(item)
                }))
            }

        }
    ]
    function changeCurrentDuration(duration) {
        return () => {
            // const onSuccess = (res) => {
            //     if (res.Error) {
            //         setErrorDialog(dispatch, res.Error, "تغییر دوره مالی");
            //     }
            //     if (res !== "PENDING") {
            //         setErrorDialog(dispatch, "success", "تغییر دوره مالی");
            //         localStorage.setItem("DurationID", duration.DurationId);
            //         localStorage.setItem("DurationName", )
            //         setCurrDuration({ Data: duration.DurationName });
            //     }
            // }
            // changeDuration(duration.DurationId, onSuccess);            
            localStorage.setItem("DurationID", duration.DurationId);
            localStorage.setItem("DurationName", duration.DurationName);
            //setChangeResult("صفحه را یکبار رفرش کنید", "تغییر دوره مالی");
            //setCurrDuration(duration.DurationName);
            window.location.reload();

        }
    }
    function prepareForClose() {
        //setPendingServices(null);
        setCloseDurationData({ CloseDate: Date.now() });
    }
    function cancelForClose() {
        setCloseDurationData(null);
        setChangeResult(null);
    }
    function startClose() {
        if (pendingClose) {
            return;
        }
        setChangeResult(null);
        setPendingClose(true);
        // setPendingServices(null);
        if ((closeDurationData.DurationName ?? "") === "" || (closeDurationData.CloseDate ?? "") === "") {
            return;
        }
        const onClose = (res) => {
            if (res.Data) {
                localStorage.setItem("DurationID", res.Data);
                localStorage.setItem("DurationName", closeDurationData.DurationName);
                setPendingClose(false);
                //setErrorDialog(dispatch, "success", "بستن دوره مالی");
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['ok'],
                    dialogTitle: 'بستن دوره مالی',
                    dialogText: 'عملیات با موفقیت انجام شد',
                    okOperation: () => { window.location.reload(); }
                }))


            }
            else if (res.PendingServices?.length > 0) {
                setCloseDurationData(null);
                setPendingServices({ Data: res.PendingServices });
                setPendingClose(false);
            }
            else if (res.Error) {
                setChangeResult("اشکال در بستن دوره مالی:" + res.Error);
                setPendingClose(false);
            }
        }
        const txt = "پیش از بستن دوره مالی از داده ها پشتیبان تهیه کنید." + (pendingServices?.Data?.length > 0 ? "آیا از بررسی سرویس ها صرف نظر می کنید؟" : "آیا از بستن دوره مالی مطمئن هستید؟");
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'بستن دوره مالی',
            dialogText: txt,
            okOperation: () => closeDuration(closeDurationData.CloseDate, closeDurationData.DurationName, pendingServices?.Data?.length > 0, onClose),
            cancelOperation: () => setPendingClose(false)
        }))
    }
    function showService(service) {
        window.open(`/Services/Service/${service.ServiceID}/${service.ServiceType}`, null);
    }
    useEffect(() => {
        if (show) {
            setPendingServices(null);
            getDurationList(setList);
            const dName = getCurrentDurationName();
            if (dName === "") {
                const onSuccess = (res) => {
                    if (res.Data) {
                        //از آنجایی که شناسه دوره مالی برای تشخیص تغییر دوره به سمت سرور فرستاده می شود؛
                        // این شناسه را تنها در صورتی ذخیره میکنیم که قصد تغییر دوره مالی را داشته باشیم
                        localStorage.setItem("DurationName", res.Data.DurationName);
                        setCurrDuration(res.Data.DurationName);
                    }
                }
                getCurrentDuration(onSuccess);
            }
            else {
                setCurrDuration(dName.replace("دوره مالی فعال:", ""));
            }
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCalendarAlt} size="lg" />&nbsp;
                    دوره های مالی
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {changeResult && <Alert variant="warning"><ExclamationCircle size={18} />&nbsp; {changeResult}</Alert>}
                <BihatmaTable columns={tableCols} dataList={list} rowButtons={tableRowButtons} maxHeight={500} />
                {closeDurationData ?
                    <div className="rowBorder" style={{ padding: "5px" }}>
                        <FormGroup>
                            <Form.Control placeholder="نام دوره مالی" style={{ display: "inline-block", width: "50%" }} onChange={e => closeDurationData.DurationName = e.target.value} />
                            <div style={{ display: "inline-block", width: "50%" }}>
                                <DatePicker className="form-control" placeholder="تاریخ آغاز دوره مالی" timePicker={false} isGregorian={false}
                                    inputJalaaliFormat="تاریخ آغاز: jYYYY/jMM/jDD"
                                    value={moment(closeDurationData.CloseDate)} onChange={val => setCloseDurationData({ ...closeDurationData, CloseDate: val.format("YYYY-MM-DD") })} />
                            </div>
                        </FormGroup>
                        <div className="mt-1">
                            <Button className="group-Btn" onClick={startClose} disabled={pendingClose}>
                                {pendingClose ?
                                    <Loader type="BallTriangle" width={18} height={18} style={{ display: "inline-block" }} color="white"/> :
                                    <Check2Circle size={18} />}
                                &nbsp;آغاز فرایند
                            </Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelForClose} disabled={pendingClose}><DashCircle size={18} />&nbsp;انصراف</Button>
                        </div>
                    </div> :
                    <Button variant="info" className="group-Btn mt-1" onClick={prepareForClose} disabled={pendingClose}>
                        <Check2Circle size={18} />&nbsp;
                        بستن آخرین دوره مالی
                    </Button>
                }
                {pendingServices?.Data &&
                    <div className="rowBorder mt-3" style={{ padding: "8px" }}>
                        <div className="rowTitle">سرویس های بدون سند:</div>
                        <BihatmaTable dataList={pendingServices} maxHeight={500} columns={pendingServicesCols} rowClick={showService} />
                    </div>
                }
                {currDuration &&
                    <div className="mt-2" style={{ padding: "6px", borderRadius: "3px", background: "linear-gradient(-45deg, #4b6ddb, transparent)", color: "whitesmoke" }}>
                        دوره مالی فعال:   {currDuration}
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalDuration;